import { ToggleOff } from 'components/icons/toggleoff'
import { ToggleOn } from 'components/icons/toggleon'
import { ImageUpload } from 'components/image-upload/component'
import { WysiwygEditor } from 'components/wysiwyg/component'
import { RasaContext } from 'context'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { isTruthy } from 'generic/utility'
import * as React from 'react'
import { Input } from 'reactstrap'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { IMAGE } from 'shared_server_client/constants'
import { getConfiguration } from '../../utils'
import { TopicPreferencesLayoutAttributes } from '../constants'
import { EditSectionProps } from '../types'

interface HeaderSettingsState {
  error: boolean,
  loadingImage: boolean
}
export class HeaderSettings extends React.Component<EditSectionProps, HeaderSettingsState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  private communityId: string = null

  constructor(props: EditSectionProps) {
    super(props)
    this.state = {
      error: false,
      loadingImage: false,
    }
    this.uploadImage = this.uploadImage.bind(this)
  }

  public componentDidMount() {
    this.sharedStore = SharedStore.instance(this.context)
    this.sharedStore.getValue(SharedKeys.activeCommunity)
    .then((activeCommunity) => {
      this.communityId = activeCommunity.communityId
    })
  }

  public render() {
    const isShowHeader: boolean =
      isTruthy(getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.ShowHeader))
    return <div className="logo-size">
      <span className="title">{this.props.name}</span>
      <div className="section">
        <div className="block">
          <div className="toggle-active"
               onClick={() => {
                 this.props.onChange(TopicPreferencesLayoutAttributes.ShowHeader, !isShowHeader)
                }}>
            <button className="toggle-button"
                    style={{background: 'none', border: 'none', outline: 'none'}}>
              {isShowHeader ? <ToggleOn/> : <ToggleOff /> }
            </button>
            <span className="small-description">Show/Hide Header Image</span>
          </div>
        </div>
      </div>
      {isShowHeader && (
        <>
          <br />
          <div className="section">
            <ImageUpload imageUrl={getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.HeaderImageUrl)}
              showCloseButton={true} closeButtonClick={() => this.props.onChange(
                TopicPreferencesLayoutAttributes.HeaderImageUrl, '')}
              uploadImage={this.uploadImage} />
          </div>
        </>
      )}
      <br />
      <div className="section">
        <div className="block">
          <div className="title">Page Title</div>
          <Input
            type="text"
            placeholder="Topic Preferences"
            value={getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.PageTitle, 'Topic Preferences')}
            onChange={(e) => this.props.onChange(TopicPreferencesLayoutAttributes.PageTitle, e.target.value)}
          />
        </div>
      </div>
      <div className="section" style={{ overflow: 'visible' }}>
        <div className="block" style={{ overflow: 'visible' }}>
          <div className="title">Page Description</div>
          <div className="topic_preferences_header_description" style={{ overflow: 'visible' }}>
            <WysiwygEditor
              htmlEdited={false}
              html={this.getHeaderDescription()}
              onChange={(html: string, isHtmlEdited: boolean) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.HeaderDescription, html)
              }}/>
          </div>
        </div>
      </div>
    </div>
  }

  private uploadImage(image: any) {
    const formData = new FormData()
    formData.append(IMAGE, image)
    const url: string = `${AjaxWrapper.getServerUrl()}/${this.communityId}/image`
    return AjaxWrapper.ajax(url, HttpMethod.POST, formData, null)
      .then((hostedImage) => {
        this.setState({
          loadingImage: false,
        })
        this.props.onChange(TopicPreferencesLayoutAttributes.HeaderImageUrl, hostedImage.url)
      })
      .catch((error) => {
        this.setState({
          error: true,
          loadingImage: false,
        })
      })
  }


  private getHeaderDescription = (): any => {
    const headerDescription = getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.HeaderDescription)
    return headerDescription ? headerDescription : 'Personalize your newsletter experience by selecting topics that matter to you.'
  }
}
